import { BaseService } from './base.service';
import { IProfileNotification } from '../models/profile-notification';
import { Uris } from '../common/constants';

export interface IProfileNotificationService {
}
export class ProfileNotificationService extends BaseService implements IProfileNotificationService {

  /**
   *
   */


  constructor() {
    super();
  }

  async getProfileNotification() {
    return super.get(Uris.NotificationEntitySettingList)
      .then((profileNotification: IProfileNotification[]) => {
        return Promise.resolve(profileNotification);
      })
      .catch((error) => Promise.reject(error))
  }

  async updateProfileNotification(notification: IProfileNotification) {
    let params = {
      sms: notification.sms,
      email: notification.email,
      app: notification.app
    }
    return await super.patch(Uris.NotificationEntitySetting.replace(':id', notification.setting_id.toString()), params)
  }

}



// WEBPACK FOOTER //
// ./src/services/profile.notification.service.ts